module.exports = __webpack_public_path__ + "static/media/dits_prev.ab1b397f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/projects/img/fun/dits_prev.png
// module id = 113
// module chunks = 0